import { t } from 'localization/utils/t';

import { EditorialLandingPage } from 'editorial/components/EditorialLandingPage';
import { NotFound } from 'error/components/NotFound';
import { IArticle } from 'editorial/types/Editorial';
import { cmsRequest } from 'server/services/cms-service/cmsRequest';
import { setServerSideTranslations } from 'localization/utils/setServerSideTranslations';
import { LOCALES, OMITTED_EDITORIAL_LOCALES } from 'localization/constants/configEnums';

const TP = 'pages.editorial.resources';

interface IEditorialPageProps {
  articles: IArticle[];
}

const EditorialPage = ({ articles }: IEditorialPageProps) => {
  if (articles?.length === 0) {
    return (
      <NotFound.Wrapper>
        <NotFound.Header>
          {t(
            `${TP}.noArticles`,
            'This page cannot be displayed at this time. Please try again later.',
          )}
        </NotFound.Header>
      </NotFound.Wrapper>
    );
  }

  return <EditorialLandingPage articles={articles} isResourcePage />;
};

export const getServerSideProps = async ({ req, locale }) => {
  if (OMITTED_EDITORIAL_LOCALES.includes(locale as LOCALES)) {
    return { notFound: true };
  }

  try {
    const requestUrl = 'api/v1/cms/cms_articles_by_group?group=resource&limit=30';
    const data = cmsRequest(req).get(requestUrl);
    const { articles }: { articles: IArticle[] } = await data.json();
    return {
      props: {
        ...(await setServerSideTranslations({ locale })),
        articles,
      },
    };
  } catch {
    return {
      props: {
        ...(await setServerSideTranslations({ locale })),
        articles: [],
      },
    };
  }
};

export default EditorialPage;
